export enum ServerMessageTypeEnum {
  RelayDocumentUpdates = 0,
  RelayClientEvents = 1,
  MessageAck = 2,
}
